import { createAction } from 'redux-actions';

export const getAllOfferBuyingAgentsAction = createAction('GET/ALL_OFFER_BUYING_AGENTS');
